import React, {useState} from 'react';
import PropTypes from 'prop-types';
import MenuList from './MenuList';
import withIntl from '../../../lib/withIntl';
import CSVImportModalContainer from '../CSVImportModal/CSVImportModalContainer';

function PicklistMenu({intl, selected, disabled, onClick, onConfirmCsvImport, tooltipMessage}) {
  const [hovered, setHovered] = useState(false);

  const [showCSVImportModal, setShowCSVImportModal] = useState(false);

  const getStyle = () => {
    if (disabled) {
      return {
        border: '1px solid #E0E0E0',
        backgroundColor: '#E0E0E0',
        color: '#999999',
      };
    }

    if (selected) {
      return {
        border: '1px solid #37C871',
        backgroundColor: 'white',
        color: '#37C871',
      };
    }

    if (hovered) {
      return {
        border: '1px solid #008F40',
        backgroundColor: '#008F40',
        color: 'white',
      };
    }

    return {
      border: '1px solid #37C871',
      backgroundColor: '#37C871',
      color: 'white',
    };
  };

  const handleClick = () => {
    if (disabled || selected) return;
    onClick();
    setShowCSVImportModal(true);
  };

  const handleCloseModal = () => {
    setShowCSVImportModal(false);
  };

  const handleConfirmCsvImport = (totalDeckIdNeedToDefine) => {
    onConfirmCsvImport(totalDeckIdNeedToDefine);
    if (showCSVImportModal) {
      setShowCSVImportModal(false);
    }
  };

  return (
    <>
      <MenuList.Item
        name={
          <div style={{color: getStyle().color}}>
            <div>{intl.formatMessage({id: 'protocolEditor.menuList.addCSVImport'})}</div>
          </div>
        }
        // eslint-disable-next-line no-nested-ternary
        imgPath={`./svg/protocol-editor/add-csv-import${selected ? '-selected' : disabled ? '-disabled' : ''}.svg`}
        onClick={handleClick}
        disabled={disabled}
        style={getStyle()}
        onMouseEnter={() => {
          setHovered(true);
        }}
        onMouseLeave={() => {
          setHovered(false);
        }}
        tooltipMessage={tooltipMessage}
      />

      <CSVImportModalContainer
        showModal={showCSVImportModal}
        onCloseModal={handleCloseModal}
        onConfirmCsvImport={handleConfirmCsvImport}
      />
    </>
  );
}

PicklistMenu.propTypes = {
  intl: PropTypes.any.isRequired,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  tooltipMessage: PropTypes.string,
  onConfirmCsvImport: PropTypes.func.isRequired,
};

PicklistMenu.defaultProps = {
  selected: false,
  disabled: false,
  onClick: () => {},
  tooltipMessage: '',
};

export default React.memo(
  withIntl(PicklistMenu),
  (prevProps, nextProps) => prevProps.selected === nextProps.selected && prevProps.disabled === nextProps.disabled,
);
